import { render, staticRenderFns } from "./CardElevationItem.vue?vue&type=template&id=7f21f935"
import script from "./CardElevationItem.vue?vue&type=script&lang=js"
export * from "./CardElevationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports